module.exports = __webpack_public_path__ + "static/media/hang-app-screenshot.e77454ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Services/img/hang-app-screenshot.png
// module id = 179
// module chunks = 0